import React, { useState } from 'react';
import { Calendar, Clock, MapPin, User, ChevronLeft, ChevronRight } from 'lucide-react';

const weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const timetableData = {
  Monday: [
    { time: '08:00 - 08:45', subject: 'Mathematics', teacher: 'Mr. Johnson', room: 'Room 101', color: 'bg-blue-500' },
    { time: '08:50 - 09:35', subject: 'Physics', teacher: 'Mrs. Smith', room: 'Lab 2', color: 'bg-purple-500' },
    { time: '09:40 - 10:25', subject: 'English', teacher: 'Ms. Davis', room: 'Room 103', color: 'bg-green-500' },
    { time: '10:40 - 11:25', subject: 'Chemistry', teacher: 'Mr. Wilson', room: 'Lab 1', color: 'bg-orange-500' },
    { time: '11:30 - 12:15', subject: 'History', teacher: 'Mr. Brown', room: 'Room 105', color: 'bg-red-500' },
    { time: '01:00 - 01:45', subject: 'Computer Science', teacher: 'Ms. Taylor', room: 'Computer Lab', color: 'bg-cyan-500' },
    { time: '01:50 - 02:35', subject: 'Physical Education', teacher: 'Mr. Clark', room: 'Sports Ground', color: 'bg-yellow-500' },
  ],
  Tuesday: [
    { time: '08:00 - 08:45', subject: 'English', teacher: 'Ms. Davis', room: 'Room 103', color: 'bg-green-500' },
    { time: '08:50 - 09:35', subject: 'Mathematics', teacher: 'Mr. Johnson', room: 'Room 101', color: 'bg-blue-500' },
    { time: '09:40 - 10:25', subject: 'Biology', teacher: 'Mrs. Anderson', room: 'Lab 3', color: 'bg-pink-500' },
    { time: '10:40 - 11:25', subject: 'Physics', teacher: 'Mrs. Smith', room: 'Lab 2', color: 'bg-purple-500' },
    { time: '11:30 - 12:15', subject: 'Geography', teacher: 'Mr. Martinez', room: 'Room 107', color: 'bg-teal-500' },
    { time: '01:00 - 01:45', subject: 'Art', teacher: 'Ms. White', room: 'Art Room', color: 'bg-indigo-500' },
    { time: '01:50 - 02:35', subject: 'Music', teacher: 'Mr. Harris', room: 'Music Room', color: 'bg-rose-500' },
  ],
  Wednesday: [
    { time: '08:00 - 08:45', subject: 'Chemistry', teacher: 'Mr. Wilson', room: 'Lab 1', color: 'bg-orange-500' },
    { time: '08:50 - 09:35', subject: 'History', teacher: 'Mr. Brown', room: 'Room 105', color: 'bg-red-500' },
    { time: '09:40 - 10:25', subject: 'Mathematics', teacher: 'Mr. Johnson', room: 'Room 101', color: 'bg-blue-500' },
    { time: '10:40 - 11:25', subject: 'English', teacher: 'Ms. Davis', room: 'Room 103', color: 'bg-green-500' },
    { time: '11:30 - 12:15', subject: 'Computer Science', teacher: 'Ms. Taylor', room: 'Computer Lab', color: 'bg-cyan-500' },
    { time: '01:00 - 01:45', subject: 'Physics', teacher: 'Mrs. Smith', room: 'Lab 2', color: 'bg-purple-500' },
    { time: '01:50 - 02:35', subject: 'Library', teacher: 'Ms. Green', room: 'Library', color: 'bg-amber-500' },
  ],
  Thursday: [
    { time: '08:00 - 08:45', subject: 'Biology', teacher: 'Mrs. Anderson', room: 'Lab 3', color: 'bg-pink-500' },
    { time: '08:50 - 09:35', subject: 'English', teacher: 'Ms. Davis', room: 'Room 103', color: 'bg-green-500' },
    { time: '09:40 - 10:25', subject: 'Chemistry', teacher: 'Mr. Wilson', room: 'Lab 1', color: 'bg-orange-500' },
    { time: '10:40 - 11:25', subject: 'Mathematics', teacher: 'Mr. Johnson', room: 'Room 101', color: 'bg-blue-500' },
    { time: '11:30 - 12:15', subject: 'Geography', teacher: 'Mr. Martinez', room: 'Room 107', color: 'bg-teal-500' },
    { time: '01:00 - 01:45', subject: 'History', teacher: 'Mr. Brown', room: 'Room 105', color: 'bg-red-500' },
    { time: '01:50 - 02:35', subject: 'Physical Education', teacher: 'Mr. Clark', room: 'Sports Ground', color: 'bg-yellow-500' },
  ],
  Friday: [
    { time: '08:00 - 08:45', subject: 'Physics', teacher: 'Mrs. Smith', room: 'Lab 2', color: 'bg-purple-500' },
    { time: '08:50 - 09:35', subject: 'Computer Science', teacher: 'Ms. Taylor', room: 'Computer Lab', color: 'bg-cyan-500' },
    { time: '09:40 - 10:25', subject: 'English', teacher: 'Ms. Davis', room: 'Room 103', color: 'bg-green-500' },
    { time: '10:40 - 11:25', subject: 'Biology', teacher: 'Mrs. Anderson', room: 'Lab 3', color: 'bg-pink-500' },
    { time: '11:30 - 12:15', subject: 'Mathematics', teacher: 'Mr. Johnson', room: 'Room 101', color: 'bg-blue-500' },
    { time: '01:00 - 01:45', subject: 'Art', teacher: 'Ms. White', room: 'Art Room', color: 'bg-indigo-500' },
    { time: '01:50 - 02:35', subject: 'Club Activities', teacher: 'Various', room: 'Various', color: 'bg-gray-500' },
  ],
  Saturday: [
    { time: '08:00 - 08:45', subject: 'Mathematics', teacher: 'Mr. Johnson', room: 'Room 101', color: 'bg-blue-500' },
    { time: '08:50 - 09:35', subject: 'Science Quiz', teacher: 'Mrs. Smith', room: 'Hall', color: 'bg-purple-500' },
    { time: '09:40 - 10:25', subject: 'English', teacher: 'Ms. Davis', room: 'Room 103', color: 'bg-green-500' },
    { time: '10:40 - 11:25', subject: 'Sports Practice', teacher: 'Mr. Clark', room: 'Sports Ground', color: 'bg-yellow-500' },
  ],
};

const Timetable = () => {
  const [selectedDay, setSelectedDay] = useState('Monday');
  const currentDayIndex = weekDays.indexOf(selectedDay);

  const goToPreviousDay = () => {
    const newIndex = currentDayIndex > 0 ? currentDayIndex - 1 : weekDays.length - 1;
    setSelectedDay(weekDays[newIndex]);
  };

  const goToNextDay = () => {
    const newIndex = currentDayIndex < weekDays.length - 1 ? currentDayIndex + 1 : 0;
    setSelectedDay(weekDays[newIndex]);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Class Timetable</h1>
          <p className="text-gray-600 mt-1">Class 10-A • Academic Year 2025-2026</p>
        </div>
        <div className="flex items-center gap-2">
          <Calendar size={20} className="text-primary-600" />
          <span className="text-sm text-gray-600">Week of Jan 13 - Jan 18, 2026</span>
        </div>
      </div>

      {/* Day Selector */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4">
        <div className="flex items-center justify-between mb-4 sm:hidden">
          <button
            onClick={goToPreviousDay}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <ChevronLeft size={20} />
          </button>
          <span className="font-semibold text-gray-900">{selectedDay}</span>
          <button
            onClick={goToNextDay}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <ChevronRight size={20} />
          </button>
        </div>
        <div className="hidden sm:flex gap-2">
          {weekDays.map((day) => (
            <button
              key={day}
              onClick={() => setSelectedDay(day)}
              className={`flex-1 py-3 px-4 rounded-lg font-medium transition-all ${
                selectedDay === day
                  ? 'bg-primary-600 text-white shadow-md'
                  : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
              }`}
            >
              {day}
            </button>
          ))}
        </div>
      </div>

      {/* Timetable for Selected Day */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="p-6 border-b border-gray-100 bg-gray-50">
          <h2 className="text-lg font-semibold text-gray-900">{selectedDay}'s Schedule</h2>
          <p className="text-sm text-gray-500 mt-1">{timetableData[selectedDay]?.length || 0} classes scheduled</p>
        </div>
        <div className="divide-y divide-gray-100">
          {timetableData[selectedDay]?.map((period, index) => (
            <div
              key={index}
              className="p-4 sm:p-6 hover:bg-gray-50 transition-colors"
            >
              <div className="flex items-start gap-4">
                <div className={`${period.color} w-1 h-full min-h-[60px] rounded-full hidden sm:block`} />
                <div className="flex-1">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                    <div>
                      <div className="flex items-center gap-2">
                        <span className={`w-3 h-3 rounded-full ${period.color} sm:hidden`} />
                        <h3 className="font-semibold text-gray-900">{period.subject}</h3>
                      </div>
                      <div className="flex flex-wrap items-center gap-4 mt-2 text-sm text-gray-500">
                        <div className="flex items-center gap-1">
                          <Clock size={14} />
                          <span>{period.time}</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <User size={14} />
                          <span>{period.teacher}</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <MapPin size={14} />
                          <span>{period.room}</span>
                        </div>
                      </div>
                    </div>
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${period.color} text-white w-fit`}>
                      Period {index + 1}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Break Time Info */}
      <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl p-6 border border-amber-200">
        <h3 className="font-semibold text-amber-800 mb-2">Break Times</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-amber-700">
          <div className="flex items-center gap-2">
            <Clock size={16} />
            <span>Short Break: 10:25 AM - 10:40 AM</span>
          </div>
          <div className="flex items-center gap-2">
            <Clock size={16} />
            <span>Lunch Break: 12:15 PM - 01:00 PM</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timetable;
